import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ConfirmationModalComponent implements OnInit {
  @Input() header: string = '';
  @Input() statement: string = '';
  @Input() comfirmButton: string = 'Confirm';
  @Input() cancelButton: string = 'Cancel';
  @Input() isOk: boolean = false;

  constructor(public activeModal: NgbActiveModal) {}
  ngOnInit(): void {}
  onYes(): void {
    this.activeModal.close(true);
  }

  onNo(): void {
    this.activeModal.close(false);
    // this.activeModal.dismiss(false);
  }
  onOk(): void {
    this.activeModal.close(true);
  }
}
